import Http from "../Http";
import { BASE_URL } from "../Helper";

export const getMenu = async ({ organizationId, applicationId }) => {
  try {
    const { data } = await Http.get(`${BASE_URL}menu/v1`, {
      params: { organizationId, applicationId },
    });
    return data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
